import type { IssuanceCertificate } from "../../../shared/models/issuance";
import { createDataStore } from "../lib/data_store";
import { get } from "aws-amplify/api";
import { API_NAME } from "../lib/amplify";

interface IssuanceDataResponse {
  certificates: IssuanceCertificate[];
}

const certificatesStore = createDataStore<IssuanceCertificate[] | undefined>();
const loadingStore = createDataStore<boolean>(false);
const errorStore = createDataStore<string | undefined>(undefined);

export const useIssuanceData = certificatesStore.useData;
export const useIssuanceLoading = loadingStore.useData as () => boolean;
export const useIssuanceError = errorStore.useData as () => string | undefined;

export async function fetchIssuanceData(
  startDate: string,
  endDate: string
): Promise<void> {
  loadingStore.setData(true);
  errorStore.setData(undefined);
  try {
    const { body } = await get({
      apiName: API_NAME,
      path: `/list-issuance-data?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`,
    }).response;
    const data = (await body.json()) as unknown as IssuanceDataResponse;
    certificatesStore.setData(data.certificates);
  } catch (err) {
    const message =
      err instanceof Error ? err.message : "Failed to fetch issuance data";
    errorStore.setData(message);
  } finally {
    loadingStore.setData(false);
  }
}
